<table
  class="short-table"
  [class.inherit-colors]="inheritColors"
  mat-table
  [dataSource]="dataSource"
>
  @for (column of columns; track $index) {
    <ng-container matColumnDef="{{ column.columnName }}">
      <mat-header-cell [class.inherit-colors]="inheritColors" *matHeaderCellDef>{{
        column.tableHeaderName
      }}</mat-header-cell>
      <mat-cell [class.inherit-colors]="inheritColors" *matCellDef="let row">
        {{ row[column.valuePropertyName] }}
      </mat-cell>
    </ng-container>
  }

  <mat-header-row
    [class.inherit-colors]="inheritColors"
    *matHeaderRowDef="getDisplayedColumns()"
  ></mat-header-row>
  <mat-row
    [class.inherit-colors]="inheritColors"
    *matRowDef="let row; columns: getDisplayedColumns()"
  ></mat-row>
</table>
